/**
 * Created by tendlich on 7/11/16.
 */
define(function (require) {
    "use strict";
    var LE = require("app");
    var CONST = require("const");
    var BaseModel = require("models/BaseModel");
    var BaseCollection = require("collections/BaseCollection");
    var ApiResources = require("assets/data/apiResources.json");
    var AttachmentModel = require("connection-models/ticketTab/AttachmentModel");
    var CommentModel = require("connection-models/ticketTab/CommentModel");
    var LEResourceResolver = require("leResourceResolver");
    var TicketModel = {};

    var KEYS = {
        ACCOUNT_ID: "accountId",
        ACCOUNT_NAME: "accountName",
        ATTACHMENTS: "attachments",
        CASE_NUMBER: "caseNr",
        CLOSED_DATE: "closedDate",
        CONTACT_EMAIL: "contactEmail",
        CONTACT_PHONE: "contactPhone",
        CONTACT_NAME: "contactName",
        CREATED_DATE: "creationDate",
        CUSTOMER_COMMENTS: "customerComments",
        DETAILS: "detailedSummary",
        ID: "id",
        IS_CLOSED: "isClosed",
        IS_PUBLIC: "isVisibleToOthers",
        LAST_UPDATE: "lastUpdate",
        PRIORITY: "priority",
        SITE_ID: "siteId",
        STATUS: "status",
        SUB_STATUS: "substatus",
        SUMMARY: "summary",
        SUPPORT_COMMENTS: "supportComments",
        ORIGIN: "origin",
        PENDING_BUG: "isBug",
        CASE_STATE: "state",
        SEVERITY: "severity"
    };

    var STATUS = {
        CASE_STATE: {
            OPEN: "open",
            CLOSED: "closed",
            BUG: "bug"
        }
    };

    var KEY_ATTRIBUTES = {
        STATUS_BUG: 'Pending Bug Process'
    };

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        TicketModel = BaseModel.extend({ //extract collection and model in two own data
            resource: ApiResources.ConnectionPanel.Ticket,
            initialize: function (options) {
                this._initDate();
                this._initResource();
                if(options){
                    if(options.contactEmail){
                        this.setContactEmail(options.contactEmail);
                    }
                    if(options.contactName){
                        this.setContactName(options.contactName);
                    }
                    if(options.siteId){
                        this.setSiteId(options.siteId);
                    }
                    if(options.accountName){
                        this.setAccountName(options.accountName);
                    }
                    if(options.accountId){
                        this.setAccountId(options.accountId);
                    }
                }
                this._determineCaseState();
            },

            _determineCaseState: function(){
                  if(this.getId()){
                      if(this.get(KEYS.IS_CLOSED) && this._isBugPending()){
                          this._setCaseState(STATUS.CASE_STATE.BUG);
                      }else if(this.get(KEYS.IS_CLOSED) && !this._isBugPending()){
                          this._setCaseState(STATUS.CASE_STATE.CLOSED);
                      }else if(!this.get(KEYS.IS_CLOSED)){
                          this._setCaseState(STATUS.CASE_STATE.OPEN);
                      }
                  }
            },

            _setCaseState: function(state){
                  this.set(KEYS.CASE_STATE,state);
            },

            _initDate: function () {
                if (this.getId()) {
                    if (this.getClosedDate()) {
                        var closedDate = this.getClosedDate();
                        this.setClosedDate(new Date(Date.UTC(closedDate.year, closedDate.month, closedDate.dayOfMonth,
                            closedDate.hourOfDay, closedDate.minute, closedDate.second)));
                        this.set("closedDateConverted", this._convertDate(this.getClosedDate()));
                    } else {
                        this.setClosedDate("");
                        this.set("closedDateConverted", "");
                    }
                    if (this.getCreatedDate()) {
                        var createdDate = this.getCreatedDate();
                        this.setCreatedDate(new Date(new Date(Date.UTC(createdDate.year, createdDate.month,
                            createdDate.dayOfMonth, createdDate.hourOfDay, createdDate.minute, createdDate.second))));
                        this.set("creationDateConverted", this._convertDate(this.getCreatedDate()));
                    } else {
                        this.set("creationDateConverted", "");
                    }
                    if (this.getLastUpdate()) {
                        var lastUpdate = this.getLastUpdate();
                        this.setLastUpdate(new Date(new Date(Date.UTC(lastUpdate.year, this.get("lastUpdate").month,
                            lastUpdate.dayOfMonth, lastUpdate.hourOfDay, lastUpdate.minute, lastUpdate.second))));
                        this.set("lastUpdateDateConverted", this._convertDate(this.getLastUpdate()));
                    } else {
                        this.setLastUpdate("");
                        this.set("lastUpdateDateConverted", "");
                    }
                }
            },

            _convertDate: function (dateObj) {
                function pad(n) {return n < 10 ? "0"+n : n;}
                var dateString = "";
                if (dateObj) {
                    if(LE.localeResolver.getLocale()===CONST.LANGUAGE["en-US"]){
                        dateString = pad(dateObj.getMonth()+1)+"/"+pad(dateObj.getDate())+"/"+dateObj.getFullYear();
                    }else{
                        dateString = pad(dateObj.getDate())+"/"+pad(dateObj.getMonth()+1)+"/"+dateObj.getFullYear();
                    }
                }
                return dateString;
            },

            _initResource: function () {
                var isAuthenticated = LE.sessionManager.isAuthenticated();
                this.resource.url = isAuthenticated ? this.resource.securedUrl : this.resource.url;
                this.resource.url = LEResourceResolver.getUrl(this.resource.url);
            },

            getCreatedDateConverted: function(){
                return this.get("creationDateConverted");
            },

            getClosedDateConverted: function(){
                return this.get("closedDateConverted");
            },

            getLastUpdateDateConverted: function(){
                return this.get("lastUpdateDateConverted");
            },

            setAccountId: function(value){
                if(_.isString(value)){
                    this.set(KEYS.ACCOUNT_ID,value);
                }
            },

            getAccountId: function(){
                return this.get(KEYS.ACCOUNT_ID);
            },

            setAccountName: function(value){
                if(_.isString(value)){
                    this.set(KEYS.ACCOUNT_NAME,value);
                }
            },

            getAccountName: function(){
                return this.get(KEYS.ACCOUNT_NAME);
            },

            getAttachments: function(){
                return this.get(KEYS.ATTACHMENTS);
            },

            getCaseNumber: function(){
                return this.get(KEYS.CASE_NUMBER);
            },


            getClosedDate: function(){
                return this.get(KEYS.CLOSED_DATE);
            },

            setClosedDate: function(value){
                this.set(KEYS.CLOSED_DATE,value);
            },

            setContactEmail: function(value){
                if(_.isString(value)){
                    this.set(KEYS.CONTACT_EMAIL,value);
                }
            },

            getContactEmail: function(){
                return this.get(KEYS.CONTACT_EMAIL);
            },

            setContactName: function(value){
                if(_.isString(value)){
                    this.set(KEYS.CONTACT_NAME,value);
                }
            },

            getContactName: function(){
                return this.get(KEYS.CONTACT_NAME);
            },

            setContactPhone: function(value){
                if(_.isString(value)){
                    this.set(KEYS.CONTACT_PHONE,value);
                }
            },

            getContactPhone: function(){
                return this.get(KEYS.CONTACT_PHONE);
            },

            getCreatedDate: function(){
                return this.get(KEYS.CREATED_DATE);
            },

            setCreatedDate: function(value){
                if(_.isDate(value)){
                    this.set(KEYS.CREATED_DATE,value);
                }
            },

            getCustomerComments: function(){
                return this.get(KEYS.CUSTOMER_COMMENTS);
            },

            getDetails: function(){
                return this.get(KEYS.DETAILS);
            },

            setDetails: function(value){
                if(_.isString(value)){
                    this.set(KEYS.DETAILS,value);
                }
            },

            setId: function(value){
                if(_.isString(value)){
                    this.set(KEYS.ID,value);
                }
            },

            getId: function(){
                return this.get(KEYS.ID);
            },

            setOrigin: function(value){
                  if(_.isString(value)){
                      this.set(KEYS.ORIGIN,value);
                  }
            },

            getOrigin: function(){
                return this.get(KEYS.ORIGIN);
            },

            isClosed: function(){
                return this.get(KEYS.CASE_STATE) === STATUS.CASE_STATE.CLOSED;
            },

            isClosedWithPendingBug: function(){
                return this.get(KEYS.CASE_STATE) === STATUS.CASE_STATE.BUG;
            },

            _isBugPending: function(){
                return this.get(KEYS.STATUS) === KEY_ATTRIBUTES.STATUS_BUG;
            },

            setVisibility: function (value) {
                if (_.isBoolean(value)) {
                    this.set(KEYS.IS_PUBLIC,value);
                }
            },

            getVisibility: function () {
                return this.get(KEYS.IS_PUBLIC);
            },

            getLastUpdate: function(){
                return this.get(KEYS.LAST_UPDATE);
            },

            setLastUpdate: function(value){
                this.set(KEYS.LAST_UPDATE,value);
            },

            getPriority: function() {
                return this.get(KEYS.PRIORITY);
            },

            getSiteId: function(){
                if(this.get(KEYS.SITE_ID)){
                    return this.get(KEYS.SITE_ID);
                }
            },

            setSiteId: function(value){
                if(_.isString(value)){
                    this.set(KEYS.SITE_ID,value);
                }
            },

            getStatus: function(){
                return this.get(KEYS.STATUS);
            },

            getSubStatus: function(){
                return this.get(KEYS.SUB_STATUS);
            },

            setSummary: function(value){
                if(_.isString(value)){
                    this.set(KEYS.SUMMARY,value);
                }
            },

            getSummary: function(){
                return this.get(KEYS.SUMMARY);
            },

            getSupportComments: function(){
                return this.get(KEYS.SUPPORT_COMMENTS);
            },

            addAttachment: function(attachment){
                var oldAttachments = _.clone(this.getAttachments(),true);
                if(_.isUndefined(oldAttachments)||_.isNull(oldAttachments)){
                    oldAttachments = [attachment.attributes];
                }else{
                    oldAttachments.push(attachment.attributes);
                }
                this.setAttachments(oldAttachments);
            },

            setAttachments: function(array){
                if(_.isArray(array)){
                    this.set(KEYS.ATTACHMENTS,array);
                }
            },

            getUnsavedAttachments: function () {
                var unsavedAttachments = [];
                _.each(this.getAttachments(), function (value) {
                    if (value.unsaved===true) {
                        unsavedAttachments.push(value);
                    }
                });
                if (unsavedAttachments.length > 0) {
                    return unsavedAttachments;
                }
                return null;
            },

            removeUnsavedAttachments: function () {
                var attachments = [];
                _.each(this.getAttachments(), function (value) {
                    if (!value.unsaved) {
                        attachments.push(value);
                    }
                });
                this.setAttachments(attachments);
            },

            removeAttachment: function(attachment){
                if(!_.isNull(attachment)){
                    var attachments = [];
                    _.each(this.getAttachments(), function (current) {
                        if(current){
                            var toDeleteId = attachment.getId();
                            var currentId = current.Id;
                            if(toDeleteId == currentId){
                                if (attachment.getTimestamp()!=current.timestamp) {
                                    attachments.push(current);
                                }
                            }
                        }
                    });
                    this.setAttachments(attachments);
                }
            },

            addUnsavedAttachment: function (attachment) {
                this._addUnsavedAttachment(attachment);
            },

            _addUnsavedAttachment: function (attachment) {
                if(attachment&&attachment instanceof AttachmentModel){
                    //add local attachments!
                    attachment.setParentId(this.getId());
                    attachment.setTimestamp(new Date());
                    attachment.setUnsaved(true);
                    //convert to attributes, because now, now no model mapped
                    this.addAttachment(attachment);
                    this.set("unsavedAttachments", true);
                }else{

                }
            },

            addCustomerComment: function (comment) {
                this._addCustomerComment(comment);
            },

            _addCustomerComment: function (comment) {
                if(comment&&comment instanceof CommentModel){
                    comment.setParentId(this.getId());
                    var oldComments = _.clone(this.getCustomerComments());
                    if(_.isUndefined(oldComments)||_.isNull(oldComments)){
                        oldComments = [comment.attributes];
                    }else{
                        oldComments.push(comment.attributes);
                    }
                    this.set(KEYS.CUSTOMER_COMMENTS,oldComments);
                }else{

                }
            },

            getAllComments: function(){
                var comments = [];
                comments = comments.concat(this.getCustomerComments());
                comments = comments.concat(this.getSupportComments());
                return comments;
            },

            setSeverity: function(value){
                this.set(KEYS.SEVERITY, value);
            },

            getSeverity: function () {
                return this.get(KEYS.SEVERITY);
            }
        });
    });
    TicketModel.KEYS = KEYS;
    return TicketModel;
});
